import React, { useEffect, useState } from "react";
import "./css/valservices.css";


const ValServices = () => {
  const [chains, setChains] = useState([]);
  const [selectedKey, setSelectedKey] = useState("");

  useEffect(() => {
    let active = true;
    fetch("/api/cosmos/chains")
      .then((response) => {
        if (!response.ok) throw new Error("Chain list unavailable");
        return response.json();
      })
      .then((data) => {
        if (active) setChains((data.chains || []).filter((chain) => chain.key && chain.prettyName)
          .sort((a, b) => a.prettyName.localeCompare(b.prettyName)));
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const selectedChain = chains.find((chain) => chain.key === selectedKey);
  const networkName = selectedChain?.prettyName;

  return (
    <div className="services-page">
      <div className="services-container">

        <h1>Validator & Node Services – Cosmos-Station</h1>

        <section>
          <h2>Professional infrastructure for Cosmos networks</h2>
          <h3>Zero Key Access. Full Peace of Mind.</h3>

          <p>
            Running a validator or node shouldn’t require you to be a
            full-time system administrator. At <strong>Cosmos-Station</strong>,
            we provide professional-grade node infrastructure and ongoing maintenance,
            so you can focus on rewards — not servers, upgrades, or downtime.
          </p>

         <div className="services-warning">
  <strong>
    Important: We never have access to your private keys, validator keys, or wallets.
    All services are delivered with zero custody and full owner control.
  </strong>
</div>

        </section>

        <section className="services-network-section">
          <h2>Choose your network</h2>
          <p>These validator and node services are available for the networks listed on Cosmos-Station.</p>
          <label htmlFor="services-network">Network</label>
          <select id="services-network" value={selectedKey} onChange={(event) => setSelectedKey(event.target.value)}>
            <option value="">All listed networks</option>
            {chains.map((chain) => <option key={chain.key} value={chain.key}>{chain.prettyName} ({chain.symbol || chain.chainId})</option>)}
          </select>
          {selectedChain && <p className="services-network-selection">Showing services for {selectedChain.prettyName} · {selectedChain.chainId}</p>}
        </section>

        <section>
          <h2>Validator Maintenance Service</h2>

          <p>
            Once your validator is live, we take full responsibility for keeping it
            online, updated, and performing optimally — without touching your keys.
          </p>

          <h3>What’s Included</h3>
          <ul>
            <li><strong>24/7 Monitoring:</strong> Continuous monitoring of uptime, performance, and validator health.</li>
            <li><strong>Network Upgrades & Software Updates:</strong> {networkName ? `Upgrades and patches for ${networkName}.` : "Upgrades and patches for each supported network."}</li>
            <li><strong>Server Maintenance & Optimisation:</strong> CPU, RAM, disk, and network tuning.</li>
            <li><strong>Security Management:</strong> Firewall configuration and SSH hardening.</li>
            <li><strong>Jail Recovery:</strong> Fast response and recovery if jailed.</li>
            <li><strong>Backup & Recovery:</strong> Secure backups of non-custodial configuration data.</li>
            <li><strong>Performance Optimisation:</strong> Ongoing tuning for uptime and reliability.</li>
            <li><strong>Support & Reporting:</strong> Clear communication and direct support.</li>
          </ul>

          <p>
            You don’t need to worry about upgrades, downtime, or technical complexity —
            we handle everything required to keep your validator secure, stable, and earning.
          </p>
        </section>

        <section>
          <h2>Node Services & Pricing</h2>
          <p><strong>Listed prices are monthly. Archive node pricing depends on the chain and storage requirements.</strong></p>

          <h3>Validator Node — £75 / month</h3>
          <ul>
            <li>Full validator infrastructure support</li>
            <li>Monitoring, updates, security, and recovery</li>
            <li><strong>No access to private keys</strong></li>
          </ul>

          <h3>Public / Private Endpoint — £50 / month</h3>
          <ul>
            <li>Reliable RPC / LCD endpoints</li>
            <li>Optimised for uptime and performance</li>
            <li>Ideal for wallets, explorers, and applications</li>
          </ul>

          <h3>Archive Node — ask for a chain-specific quote</h3>
          <ul>
            <li>Full historical blockchain data</li>
            <li>High-capacity storage and optimised performance</li>
            <li>Suitable for analytics and explorers</li>
          </ul>
        </section>

        <section>
          <h2>Our Principles</h2>
          <ul>
            <li>✔️ You own your keys — always</li>
            <li>✔️ Zero custodial access — ever</li>
            <li>✔️ Professional-grade infrastructure</li>
            <li>✔️ Real validator & network experience</li>
          </ul>
        </section>

        <section>
          <h2>Get in touch</h2>
       <p>
  If you’re looking for reliable {networkName || "Cosmos network"} infrastructure without the
  stress of running it yourself, Cosmos-Station has you covered.
  <br /><br />

  <a
    href="https://t.me/+yX9csWRwuMJiNzhk"
    target="_blank"
    rel="noopener noreferrer"
  >
    Telegram
  </a>
  <br />

  <a
    href="https://t.me/DncLunc82"
    target="_blank"
    rel="noopener noreferrer"
  >
    Contact @DncLunc82
  </a>
  <br />

  <a
    href="https://x.com/LCSbyDNC"
    target="_blank"
    rel="noopener noreferrer"
  >
    X @LCSbyDNC
  </a>
</p>

        </section>

      </div>
    </div>
  );
};

export default ValServices;
